export default {
  setLocale ({ commit }, locale) {
    commit('SET_LOCALE', locale)
  }
}
